import Vue from 'vue'
import Router from 'vue-router'

import Presentation from './pages/Presentation'
import messages from './locales'

Vue.use(Router)

const routes = [
  // {
  //   path: '/',
  //   name: 'presentation',
  //   component: Presentation
  // },
  {
    path: '/:presentation',
    name: 'Presentation',
    component: Presentation
  },
  {
    path: '/:presentation/:sequence',
    name: 'Sequence',
    component: Presentation
  }
  // {
  //   path: '*',
  //   redirect: '/'
  // }
]

let langRoutes = []

for (let i = 0; i < routes.length; i++)  {
  for (const locale of Object.keys(messages)) {
    const prefix = locale === 'en' ? '' : '/' + locale + ''
    let route = {...routes[i]}
    route.path = prefix + route.path
    route.name = locale + '/' + route.name
    route.meta = {
      ...routes[i].meta,
      locale: locale
    }

    langRoutes.push(route)
  }
}
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL || '/',
  routes: routes
})
